
import Layout from "@/components/views/layouts/Layout";
import Landing from "@/components/views/layouts/Landing";
import NotFound from "@/components/views/layouts/NotFound";
import Register from "./routes/Register";
import CompleteProfile from "@/routes/young/CompleteProfile";
import CompleteAdvisorProfile from "@/routes/advisor/CompleteProfile";
import CompleteInstructorProfile from "@/routes/instructor/CompleteInstructorProfile";
import SecondStepYoung from "@/routes/young/SecondStepYoung";
import Inbox from "@/routes/company/Inbox";
import Tutor from "@/routes/company/Tutor";

import Young from "@/routes/company/Young";
import Company from "@/routes/company/Company";
import Workplace from "@/routes/company/Workplace";
import Training from "@/routes/company/Training";
import Emails from "@/routes/company/Emails";




const Login = _ => import(/* webpackChunkName: "js/split/Login", webpackPreload: true */ '@/components/views/register/partials/Login');
const SignUp = _ => import(/* webpackChunkName: "js/split/SignUp", webpackPreload: true */ '@/components/views/register/partials/SignUp');

const ValidateAccount = _ => import(/* webpackChunkName: "js/split/ValidateAccount", webpackPreload: true */ '@/components/views/register/ValidateAccount');
import PanelHome from "@/components/views/home/PanelHome";
import InstructorHome from "@/components/views/home/instructor/InstructorHome";
import Recover from "@/components/views/register/Recover";


import utils from '@/utils/utils';
const { checkExistsInfoUser, checkProfile } = utils;




const redirectHome = _ =>{
	if(window.sessionStorage.getItem("sre_young_token") ){
		return {
			path: '',
			component: PanelHome,
			name: 'PanelHome',
			meta: {
				auth: true,
			}
		}
	}else{
		return {
			path: '',
			component: Landing,
			name: 'Landing',
			meta: {
				onlyGuest: true,
			}
		}
	}

};

export const routes = [
	
	{
		path: '/',
		component: Layout,
		children: [
			redirectHome(),
			{
				path: 'inicio',
				component: PanelHome,
				meta: {
					auth: true,
				}
			},
			{
				path: 'instructor',
				component: InstructorHome,
				meta: {
					auth: true,
				}
			},		
			{
				path: 'login',
				component: Login,
				name: 'login',
				meta: {
					onlyGuest: true,
				}
			},
			{
				path: 'registrarse',
				component: SignUp,
				name: 'signUp',
				meta: {
					onlyGuest: true,
				}
			},
			{
				path: 'validar-cuenta/:token/:userId',
				component: ValidateAccount,
				name: 'validateAccount',
				props: true,
				meta: {
					auth: false,
				}
			},
			{
                path: 'password/restore/:email/:id',
                component: Recover,
                meta: {
					onlyGuest: true,
				}
				
            },

			{...Register},
			{...CompleteProfile},
			{...CompleteAdvisorProfile},
			{...CompleteInstructorProfile},
			{...Inbox},
			{...Tutor},
			{...Young},
			{...Company},
			{...SecondStepYoung},
			{...Workplace},
			{...Training},
			{...Emails},
			{
				path: '404',
				component: NotFound,
				meta: {
					auth: false,
				}
			},
		]
	},
	{
		path: '*',
		redirect: '/404',
		meta: {
			guest: true,
		}
	}
];
